import type {
    GrupoTransferenciaModel,
    ResumoEstabelecimentoModel,
} from "../models/extratoPixFornecedorModel"

export enum ExtratoPixFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    SET_DATA_INICIO = "SET_DATA_INICIO",
    SET_DATA_FIM = "SET_DATA_FIM",
}

export type ExtratoPixFornecedorActions =
    | {
          type: ExtratoPixFornecedorActionsTypes.CARREGAR
          payload: {
              grupos: GrupoTransferenciaModel[]
              resumo: ResumoEstabelecimentoModel[]
              saldo: string
          }
      }
    | { type: ExtratoPixFornecedorActionsTypes.SET_DATA_INICIO; payload: string }
    | { type: ExtratoPixFornecedorActionsTypes.SET_DATA_FIM; payload: string }
